import React from 'react'

import { StatusBar as ExpoStatusBar} from 'expo-status-bar'
import { useIsFocused } from '@react-navigation/native'

import * as pocketPick from '@/router/(root)/pocketPick/pocketPickModule'
import * as cth from '@/router/(root)/cth/cthModule'
import * as d10 from '@/router/(root)/daily10/d10Module'

import { defaultTheme } from '@/components/Mini/theme'

function D10StatusBar(){

  const theme = d10.useStore(s => s.theme)

  return (
    <StatusBar theme={theme}/>
  )
}

function PocketPickStatusBar(){

  const theme = pocketPick.useStore(s => s.theme)

  return (
    <StatusBar theme={theme}/>
  )
}

function CthStatusBar(){

  const theme = cth.useStore(s => s.theme)

  return (
    <StatusBar theme={theme}/>
  )
}

function StatusBar({theme=defaultTheme}){

  const isFocused = useIsFocused()

  const mode = theme.isDark ? "light" : "dark"

  return (
    isFocused ? <ExpoStatusBar style={mode} /> : null
  )
}

export { StatusBar, CthStatusBar, D10StatusBar, PocketPickStatusBar }
